import { useTranslation } from "react-i18next";
import { CustomIcon } from "components/icon/customIcon.component";
import { ColorV2 } from "config/colors";
import { formatNumber } from "utils/utils";
import {
  AmountInput,
  AmountInputShell,
  AmountSuffix,
  DistributionCell,
  DistributionGrid,
  DistributionHeaderCell,
  TeamAmount,
  WorkerAvatar,
  WorkerIdentity,
  WorkerName,
} from "./tips.distributionModal.styled";
import type {
  HandleTeamPercentageChangeParams,
  TeamPercentages,
  TeamRows,
} from "./tips.distributionModal.types";

interface TipsDistributionTeamRowsProps {
  readonly teamPercentages: TeamPercentages;
  readonly teamRows: TeamRows;
  readonly onTeamPercentageBlur: () => void;
  readonly onTeamPercentageChange: (
    params: HandleTeamPercentageChangeParams,
  ) => void;
}

export const TipsDistributionTeamRows = (
  props: TipsDistributionTeamRowsProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <DistributionGrid>
      <DistributionHeaderCell>
        {t("Tips.DistributionTeam")}
      </DistributionHeaderCell>
      <DistributionHeaderCell />
      <DistributionHeaderCell>
        {t("Tips.DistributionAmount")}
      </DistributionHeaderCell>
      {props.teamRows.flatMap((team) => [
        <DistributionCell key={`${team.workGroupId}-team`}>
          <WorkerIdentity>
            <WorkerAvatar>
              <CustomIcon name="v2/person" size="16px" color={ColorV2.Blue1} />
            </WorkerAvatar>
            <WorkerName>{team.workGroupName}</WorkerName>
          </WorkerIdentity>
        </DistributionCell>,
        <DistributionCell key={`${team.workGroupId}-amount`}>
          <TeamAmount>
            {formatNumber(team.amount)} {t("Tips.Currency")}
          </TeamAmount>
        </DistributionCell>,
        <DistributionCell key={`${team.workGroupId}-percentage`}>
          <AmountInputShell>
            <AmountInput
              aria-label={t("Tips.DistributionPercentageForTeam", {
                team: team.workGroupName,
              })}
              inputMode="numeric"
              maxLength={3}
              onBlur={props.onTeamPercentageBlur}
              onChange={(event) =>
                props.onTeamPercentageChange({
                  value: event.target.value,
                  workGroupId: team.workGroupId,
                })
              }
              value={props.teamPercentages[team.workGroupId] ?? ""}
            />
            <AmountSuffix>%</AmountSuffix>
          </AmountInputShell>
        </DistributionCell>,
      ])}
    </DistributionGrid>
  );
};
